import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import BoxWithIcon from "../atoms/ComponentBox/BoxWithIcon";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import { selectPermissions } from '../redux/permissionsSlice';
import fetchStatusCounts from '../GlobalFunction/Counts';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const ARAP = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const permissions = useSelector(selectPermissions);

  const [counts, setCounts] = useState([]);

  // Parent ID for fetching status counts 
  const parentId = 26;

  // useEffect to fetch counts
  useEffect(() => {
    const getCounts = async () => {
      const data = await fetchStatusCounts(parentId);
      setCounts(data);
    };
    getCounts();
  }, [parentId]);

  // Function to find count data for a specific module by ModuleName
  const matchedItem = (moduleName) => {
    return counts.find(item => item.ModuleName === moduleName);
  };

  // Store matched count data for each module
  const matchResident = matchedItem('Resident Master');
  const matchVendor = matchedItem('Vendor Master');
  const matchCorporate = matchedItem('Corporate Master');
  const matchInstitute = matchedItem('Institute Master');
  const matchCourse = matchedItem('Course Master');
  const matchSemester = matchedItem('Semester Master');
  const matchSource = matchedItem('Source Master');
  // const matchBank = matchedItem('Bank Master');
  const matchRelation = matchedItem('Relation Master');
  const matchClass = matchedItem('Class Master');
  const matchRating = matchedItem('Rating Master');

  const handleBoxClick = (path) => {
    navigate(path, { state: { permissions } });
  };

  const hasModulePermission = (moduleName) => {
    const modulePermission = permissions.find(
      permission => permission.ModuleName === moduleName
    );

    if (!modulePermission) return false;

    return (
      modulePermission.AddRec === "1" ||
      modulePermission.EditRec === "1" ||
      modulePermission.DeleteRec === "1" ||
      modulePermission.ViewRec === "1"
    );
  };

  const names = [
    "Resident Master",
    "Vendros & Creditors",
    "Corporate Master",
    "Institute Master",
    "Course Master",
    "Semester Master",
    "Source Master",
    "Bank Master",
    "Relation Master"
  ];

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid
        container
        sx={{
          width: "100%",
          maxWidth: "100%"
        }}
      >
        <Grid item xs={12}>
          <Grid container spacing={1}>
            {hasModulePermission("Resident Master") && matchResident && (
              <BoxWithIcon
                totalCount={matchResident.TotalCount}
                activeCount={matchResident.ActiveCount}
                inactiveCount={matchResident.InactiveCount}
                link={{ pathname: "/masters/residenttable" }}
                permissions={permissions}
                title="Resident Master"
              />
            )}
            {hasModulePermission("Vendor Master") && matchVendor && (
              <BoxWithIcon
                totalCount={matchVendor.TotalCount}
                activeCount={matchVendor.ActiveCount}
                inactiveCount={matchVendor.InactiveCount}
                link={{ pathname: "/partytable" }}
                permissions={permissions}
                title="Vendors & Creditors"
              />
            )}
            {hasModulePermission("Corporate Master") && matchCorporate && (
              <BoxWithIcon
                totalCount={matchCorporate?.TotalCount}
                activeCount={matchCorporate?.ActiveCount}
                inactiveCount={matchCorporate?.InactiveCount}
                link={{ pathname: "/corporateTable" }}
                permissions={permissions}
                title="Corporate Master"
              />
            )}
            {hasModulePermission("Institute Master") && matchInstitute && (
              <BoxWithIcon
                totalCount={matchInstitute.TotalCount}
                activeCount={matchInstitute.ActiveCount}
                inactiveCount={matchInstitute.inactiveCount}
                link={{ pathname: "/instituteMasterTable" }}
                permissions={permissions}
                title="Institute Master"
              />
            )}

            {hasModulePermission("Course Master") && matchCourse && (
              <BoxWithIcon
                totalCount={matchCourse?.TotalCount}
                activeCount={matchCourse?.ActiveCount}
                inactiveCount={matchCourse?.InactiveCount}
                link={{ pathname: "/coursetable" }}
                permissions={permissions}
                title="Course Master"
              />
            )}

            {hasModulePermission("Semester Master") && matchSemester && (
              <BoxWithIcon
                totalCount={matchSemester.TotalCount}
                activeCount={matchSemester.ActiveCount}
                inactiveCount={matchSemester.InactiveCount}
                link={{ pathname: "/semestertable" }}
                permissions={permissions}
                title="Semester Master"
              />
            )}
            {hasModulePermission("Source Master") && matchSource && (
              <BoxWithIcon
                totalCount={matchSource.TotalCount}
                activeCount={matchSource.ActiveCount}
                inactiveCount={matchSource.InactiveCount}
                link={{ pathname: "/sourceMstTable" }}
                permissions={permissions}
                title="Source Master"
              />
            )}
            {/* {hasModulePermission("Bank Master") && matchBank && (
              <BoxWithIcon
                totalCount={matchBank.TotalCount}
                activeCount={matchBank.ActiveCount}
                inactiveCount={matchBank.InactiveCount}
                link={{ pathname: "/bank-table" }}
                permissions={permissions}
                title="Bank Master"
              />
            )} */}
            {hasModulePermission("Relation Master") && matchRelation && (
              <BoxWithIcon
                totalCount={matchRelation.TotalCount}
                activeCount={matchRelation.ActiveCount}
                inactiveCount={matchRelation.InactiveCount}
                link={{ pathname: "/relation-table" }}
                permissions={permissions}
                title="Relation Master"
              />
            )}
            {hasModulePermission("Class Master") && matchClass && (
              <BoxWithIcon
                totalCount={matchClass.TotalCount}
                activeCount={matchClass.ActiveCount}
                inactiveCount={matchClass.InactiveCount}
                link={{ pathname: "/classtable" }}
                permissions={permissions}
                title="Class Master"
              />
            )}
            {hasModulePermission("Rating Master") && matchRating && (
              <BoxWithIcon
                totalCount={matchRating.TotalCount}
                activeCount={matchRating.ActiveCount}
                inactiveCount={matchRating.InactiveCount}
                link={{ pathname: "/ratingtable" }}
                permissions={permissions}
                title="Rating Master"
              />
            )}
            {hasModulePermission("EnqType Master") && (
              <BoxWithIcon
                totalCount={10}
                activeCount={10}
                inactiveCount={10}
                link={{ pathname: "/EnqTypeTable" }}
                permissions={permissions}
                title="EnqType Master"
              />
            )}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ARAP;